<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{subrentalEntryModel.inventoryEntryId}}" class="head col-12 col-lg-12">
                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalEntryModel.branchName}}</p>

                  <!--Nombre Entrada Subalquiler -->
                  <p id="nombre-entrada-subalquiler-{{subrentalEntryModel.inventoryEntryId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'ENTRADA SUBALQUILER Nro.'+ subrentalEntryModel.consecutive}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion'
                    | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalEntryModel.address}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalEntryModel.phone}}</p>


                  <!-- Fecha Entrada -->
                  <label id="t-fecha-entrada-subalquiler-{{subrentalEntryModel.inventoryEntryId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-entrada-subalquiler' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-entrada-subalquiler-{{subrentalEntryModel.inventoryEntryId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{subrentalEntryModel.dateEntry | date: 'dd/MM/yyyy'}}</p>

                  <!-- Remisión  -->
                  <label id="t-remision-{{subrentalEntryModel.inventoryEntryId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-remision' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="remision-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalEntryModel.remission}}</p>

                  <!-- Valor Transporte -->
                  <label id="t-valor-transporte-{{subrentalEntryModel.inventoryEntryId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-valor-transporte' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-transporte-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{subrentalEntryModel.transportValue | currency}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-entrada-subalquiler-{{subrentalEntryModel.inventoryEntryId}}"
                  [columns]="columns" [data]="subrentalEntryModel.subrentalEntryDetails" [idMap]="idMap"
                  [documentId]="subrentalEntryModel.inventoryEntryId" [footerVisible]="true" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{subrentalEntryModel.inventoryEntryId}}" class="foot mt-1 container-observations">
                <label id="t-observacion-entrada-subalq-{{subrentalEntryModel.inventoryEntryId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="subrentalEntryModel.observation">{{'t-observacion-entrada-subalq' |
                  formatLabelPipe : elementsLabel}}</label>
                <p id="observacion-entrada-subalquiler-{{subrentalEntryModel.inventoryEntryId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" *ngIf="subrentalEntryModel.observation">
                  {{subrentalEntryModel.observation}}</p>

                <!-- Firma Revisado-->
                <p id="linea-firma-revisado-{{subrentalEntryModel.inventoryEntryId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-revisado-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-revisado' | formatLabelPipe : elementsLabel}}</label>

                <!-- Firma Recibe-->
                <p id="linea-firma-recibe-{{subrentalEntryModel.inventoryEntryId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-recibe-{{subrentalEntryModel.inventoryEntryId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-recibe' | formatLabelPipe : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>